import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConstants } from 'src/app/app.constant';
import { TableColumn } from 'src/app/interfaces/TableColumn';
import { CommonService } from 'src/app/service/common.service';
import { GenericService } from 'src/app/service/generic.service';
import { MenuService } from 'src/app/service/menu.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-generic',
  templateUrl: './generic.component.html',
  styleUrls: ['./generic.component.scss'],
})
export class GenericComponent implements OnInit {
  public displayedColumns: TableColumn[] = [
    {
      name: 'ID',
      dataKey: 'id',
      isSortable: true,
      cell: (element: Record<string, any>) => `${element['id']}`,
    },
    {
      name: 'Drug Generic Name',
      dataKey: 'generic_name',
      isSortable: true,
      cell: (element: Record<string, any>) => `${element['generic_name']}`,
    },
    {
      name: 'Participants Count',
      dataKey: 'participant_count',
      isSortable: true,
      cell: (element: Record<string, any>) => ({
        content: element['participant_count'],
        keyName: 'drug-generic/generic_id',
      }),
    },
    // {
    //   name: 'Participants Count Brand',
    //   dataKey: 'participant_count_brand',
    //   isSortable: true,
    //   cell: (element: Record<string, any>) => ({
    //     content: element['participant_count_brand'],
    //     keyName: 'drug-generic/generic_id',
    //   }),
    // },
    {
      name: 'Rxcui ID',
      dataKey: 'rxcui_id',
      isSortable: true,
      cell: (element: Record<string, any>) => `${element['rxcui_id']}`,
    },
    {
      name: 'Category Name',
      dataKey: 'category_name',
      isSortable: true,
      cell: (element: Record<string, any>) => `${element['category_name']}`,
    },
    {
      name: 'SNOMED ID',
      dataKey: 'snomed_id',
      isSortable: true,
      cell: (element: Record<string, any>) => `${element['snomed_id']}`,
    },
  ];

  public title = 'Drug Generic';
  public totalRows = 0;
  public pageSize = 10;
  public currentPage = 0;
  public filterValue = '';
  public sortField = '';
  public sortOrder = '';
  public pageSizeOptions: number[] = AppConstants.pageSizeOptions;
  public loading: boolean = false;
  public data: any;
  public isApproved: number = 1;
  public editLink = 'dictionary-management/drug-generic/edit/';
  public currentMenuPermission: any;
  public is_data_curation_access : boolean = false;

  constructor(
    private genericService: GenericService,
    private commonService: CommonService,
    protected router: Router,
    private route: ActivatedRoute,
    private menuService: MenuService
  ) {}

  ngOnInit(): void {
    this.is_data_curation_access = JSON.parse(localStorage.getItem('userInfo') as string).is_data_curation_access;
    this.menuService.currentMenu.subscribe(currentMenu => {
      this.currentMenuPermission = currentMenu;
    });
    this.route.queryParams.subscribe((queryParams: any) => {
      this.isApproved =
        this.router.url.indexOf('curation-pending') >= 0 ? 0 : 1;
      this.getAll();
    });
  }

  /**
   * This function is user to get all User Listing
   * @author Dhaval Bera
   */
  getAll() {
    this.loading = true;
    this.genericService
      .getRecordByFilter(
        this.currentPage + 1,
        this.sortField,
        this.sortOrder,
        this.filterValue,
        this.pageSize,
        this.isApproved
      )
      .subscribe({
        next: (result: any) => {
          this.loading = false;
          this.data = result.data.data;
          this.totalRows = result.data.total;
        },
        error: (e) => {
          this.loading = false;
          console.log('Generic Listing err :: ', e);
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  downloadParticipantData(url:string){
    if (this.currentMenuPermission.edit == true) {
      this.loading = true;
      this.genericService.downloadDictionaryParticipantList(url).subscribe({
        next: (result: any) => {
          console.log(result);
          const file = new Blob([result.data.body], { type: 'text/csv' });
          var downloadURL = window.URL.createObjectURL(file);
          var link = document.createElement('a');
          link.href = downloadURL;
          link.download = result.data.file_name;
          link.click();
        },
        error: () => { },
        complete: () => {
          this.loading = false;
        },
      });
    }
  }

  editAction(event: any) {
    this.router.navigate([this.editLink + event.id]);
  }
  /**
   * call Create Organ site api
   * @returns null
   */
  deleteGeneric(event: any) {
    Swal.fire({
      title: 'Delete?',
      html: 'Are you sure want to delete the Drug Generic?',
      imageUrl: '../../../../../assets/images/delete.svg',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      customClass: {
        confirmButton: 'btn mat-secoundary',
        cancelButton: 'btn mat-warn ml-1',
      },
    }).then((result) => {
      if (result.value) {
        this.genericService.delete(event.id).subscribe({
          next: (result: any) => {
            if (result.status === AppConstants.serverSuccessStatus) {
              this.commonService.showSuccessToast(
                result.message
              );
              this.getAll();
            } else {
              this.commonService.showErrorToast(
                // "Generic can't be deleted. Please try again later."
                result.message
              );
            }
          },
          error: (e: any) => {
            this.commonService.showErrorToast('Generic not found');
          },
        });
      }
      if (result.dismiss === Swal.DismissReason.cancel) {
      }
    });
  }

  /**
   * Make unapproved records
   * @param id
   */
  makeUnapproved(event: any) {
    Swal.fire({
      title: 'Unapproved?',
      html: 'Are you sure want to unapproved the Generic?',
      imageUrl: '../../../../../assets/images/unapproved.svg',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      customClass: {
        confirmButton: 'btn mat-secoundary',
        cancelButton: 'btn mat-warn ml-1',
      },
    }).then((result) => {
      if (result.value) {
        let url = (
          `${environment.baseURL}` + 'dictionary/unapproved/drug-generic/' + event.id
        );
        this.genericService
          .makeUnapprovedDictionary(url)
          .subscribe((results: any) => {
            if (results.status === 1 || results.status === 200) {
              this.commonService.showSuccessToast(
                'Generic unapproved successfully'
              );
              this.getAll();
            } else {
              this.commonService.showErrorToast(
                results.message
                // "Generic can't be unapproved. Please try again later."
              );
            }
          });
      }
      if (result.dismiss === Swal.DismissReason.cancel) {
      }
    });
  }

  searchFilter(filterValue: any) {
    this.filterValue = filterValue;
    this.currentPage = 0;
    this.getAll();
  }
  SortFilter(sortState: any) {
    if (sortState.active !== '' && sortState.direction !== '') {
      this.sortField = sortState.active;
      this.sortOrder = sortState.direction;
      this.getAll();
    }
  }
  pageChanged(event: any) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getAll();
  }
}
